export default "__VITE_ASSET__Crd7aWSt__"